/** @format */

import { Alert } from '@mui/material';
import { useCountdown } from '../../app/useTimer';
import { ShowCounter } from './ShowCounter';

interface Props {
  targetDate: Date;
}
export const CountdownTimer = ({ targetDate }: Props) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return (
      <>
        <Alert variant='standard' color='warning' sx={{ marginTop: 4 }}>
          Hi Applicant! Please note that Applications are closed for this year.
        </Alert>
      </>
    );
  } else {
    return (
      <ShowCounter
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
      />
    );
  }
};
